export const colors = {
  accentPrimary: '#142D6F',
  accentSecondary: '#648BEF',
  accentTertiary: '#8DC0F9',
  accentWhite: '#FFFFFF',
  accentQuaternary: '#ECF0FF',
  accentQuaternary2: '#EDF2F7',
  accentQuaternary3: '#D4DBE3',
  accentQuaternary4: '#C1CAD5',
  accentQuaternary5: '#9AA6B2',
  accentQuaternary6: '#6B7A89',
  accentQuaternary7: '#46535F',
  accentQuaternary8: '#293139',
  hoverState: '#1847C0',
  clickState: '#2356D9',
  errorState: '#FF3030',
  errorLight: '#FFF2F2',
  dark: '#181818',
};
